import { render, staticRenderFns } from "./KnGroupGroups.vue?vue&type=template&id=70dc1792&"
import script from "./KnGroupGroups.vue?vue&type=script&lang=js&"
export * from "./KnGroupGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports